// extracted by mini-css-extract-plugin
export default {"header":"WzQmup","wrapper":"zor8R2","reviews-with-padding":"Rs3dOD","content-wrapper":"ApGNMO","tag-wrapper":"K1CgBm"};